import { Employer } from '@libs/models';
import { EmployerCreateDto, EmployerUpdateDto, Pagination } from '@libs/dto';
import { PaginatedQueryParams } from '@libs/types';

import { api } from '../common.api';

export const employerApi = api.injectEndpoints({
  endpoints: (build) => ({
    employerCreate: build.mutation<Employer, EmployerCreateDto>({
      query: (body) => ({
        url: '/employer',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Employer'],
    }),
    employerIndex: build.query<Pagination<Employer>, { page?: number; limit?: number }>({
      query: ({ page = 1, limit = 10 } = {}) => ({
        url: '/employer',
        method: 'GET',
        params: { page, limit },
      }),
      providesTags: ['Employer'],
    }),
    employerSearch: build.query<Pagination<Employer>, PaginatedQueryParams>({
      query: ({ q, page = 1, limit = 10 }) => ({
        url: '/employer/search',
        method: 'GET',
        params: { q, page, limit },
      }),
      providesTags: ['Employer'],
    }),
    employerView: build.query<Employer, number>({
      query: (id) => ({
        url: `/employer/${id}`,
        method: 'GET',
      }),
      providesTags: ['Employer'],
    }),
    employerUpdate: build.mutation<Employer, EmployerUpdateDto>({
      query: (body) => ({
        url: `/employer/${body.id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Employer'],
    }),
    employerDelete: build.mutation<Employer, number>({
      query: (id) => ({
        url: `/employer/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Employer'],
    }),
    employerProfile: build.query<Employer, number>({
      query: (id) => ({
        url: `/employer/user/${id}`,
        method: 'GET',
      }),
      providesTags: ['Employer'],
    }),
  }),
});

export const {
  useEmployerCreateMutation,
  useEmployerIndexQuery,
  useEmployerSearchQuery,
  useEmployerViewQuery,
  useEmployerUpdateMutation,
  useEmployerDeleteMutation,
  useLazyEmployerProfileQuery,
  useEmployerProfileQuery,
} = employerApi;
